import React from 'react';
import Box from '@mui/system/Box';
import Typography from '@mui/material/Typography';

/**
 * Renders title and content for use inside MUI Tooltip.
 * @param {string} [title] - Optional tooltip title
 * @param {string|string[]} [content] - Optional tooltip content (string or array of strings for multiple paragraphs)
 * @param {React.ReactNode} [body] - Optional custom body content override
 */
const NRTooltipContent = ({ title, content, body }) => {
  if (!title && !content && !body) {
    return null;
  }

  const paragraphs = Array.isArray(content) ? content : [content];

  return (
    <Box>
      {title && (
        <Typography variant="caption" sx={{ mb: 0.5, fontWeight: 'bold' }}>
          {title}
        </Typography>
      )}
      {body ||
        (content &&
          paragraphs.map((paragraph, index) => (
            <Typography key={index} component="p" variant="caption" sx={index > 0 ? { mt: 1 } : {}}>
              {paragraph}
            </Typography>
          )))}
    </Box>
  );
};

export default NRTooltipContent;
